class Controller {
  constructor($mdDialog, $injector, option) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.option = option;
  }

  close() {
    this.$mdDialog.cancel();
  }

  find() {
    if (!this.typed || !this.option.resource) return;

    this.hasError = false;
    this.$injector
      .get(this.option.resource)
      .find(this.typed)
      .$promise.then(
        (response) => {
          this.$mdDialog.hide(response);
        },
        () => {
          this.hasError = true;
        }
      );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/dialogs/exactDialog/exactDialog.controller.js